import { useMemo } from 'react';
import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';
import { useSearchParams } from '../../lib/searchParams';
import { createObjFromParams } from '../../lib/utils';

const keys = {
  list: (params) => ['shutdownList', params],
  byId: (id) => {
    return ['shutdown', typeof id === 'number' ? id : Number(id)];
  },
};

const listQuery = async ({ queryKey }) => {
  const [_, params] = queryKey;

  return await request.get(
    `/Alert`,
    params,
    `При загрузке отключений произошла ошибка`,
    undefined,
    'comma'
  );
};
const listOptions = (params, options = {}) => [
  keys.list(params),
  listQuery,
  options,
];

const byIdQuery = async ({ queryKey }) => {
  const [_, id] = queryKey;

  return await request.get(
    `/Alert/${id}`,
    {},
    `При загрузке отключения ${id} произошла ошибка`
  );
};
const byIdOptions = (id, options = {}) => [keys.byId(id), byIdQuery, options];

const getIdWithRest = (params) => {
  const { search, isNew, fromNotification, ...rest } = params;

  return {
    id: isNew || fromNotification || search,
    rest,
  };
};

const getOptions = (props) => {
  const { params, size } = props;

  const { id, rest } = getIdWithRest(params);

  return id
    ? byIdOptions(id, { enabled: size > 0 })
    : listOptions(rest, { enabled: size > 0 });
};

const getShutdownsQueryKey = (searchParams) => {
  const { params } = createObjFromParams(searchParams);

  const { id, rest } = getIdWithRest(params);

  return id ? keys.byId(id) : keys.list(rest);
};

export const useShutdownsQueryKey = () => {
  const [searchParams] = useSearchParams();
  return getShutdownsQueryKey(searchParams);
};

export const useShutdowns = () => {
  const [searchParams] = useSearchParams();

  const queryArgs = useMemo(() => {
    const params = createObjFromParams(searchParams);
    return getOptions(params) || [];
  }, [searchParams.toString()]);

  return useQuery(...queryArgs);
};

export const fetchShutdown = async ({ queryClient, id }) =>
  await queryClient.fetchQuery(keys.byId(id), byIdQuery);
